export const injectHrefIntoLinks = (url) => {
    document.querySelectorAll('.link').forEach((link) => {
        link.setAttribute('href', url);
    });
};
